(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/video-analysis-controller.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/video-analysis-controller.js');
"use strict";


const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  selectMatchVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors;
const {
  setCurrentVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const VideoAnalysisController = _ref => {
  let {
    eventNumber
  } = _ref;
  const dispatch = useDispatch();
  const matchVideo = useSelector(state => selectMatchVideo(state, eventNumber));
  const hasVideo = Boolean(matchVideo);
  const handlePlayVideo = () => {
    if (hasVideo) {
      dispatch(setCurrentVideo(matchVideo));
    }
  };
  return React.createElement("div", {
    className: "video-analysis-controller"
  }, React.createElement("button", {
    "aria-label": hasVideo ? "Play video analysis for match ".concat(eventNumber) : "No video available for match ".concat(eventNumber),
    className: "video-analysis-button",
    disabled: !hasVideo,
    onClick: handlePlayVideo,
    type: "button"
  }, "Videoanalys"));
};
setGlobal('svs.components.tipsen.coupon.VideoAnalysisController', VideoAnalysisController);

 })(window);